import richText from "utilities/richText"

export default function BracketedSection({ blok }) {
  return (
    <section className="px-5 py-8 lg:py-16 bg-highlight-tint overflow-hidden">
      <div className="flex flex-col lg:flex-row gap-7 max-w-screen-lg mx-auto relative form-brackets form-brackets-highlight-tint before:w-[68px] before:h-[272px] before:-left-32 after:w-[68px] after:h-[272px] after:-right-32">
        <div className="basis-1/3">
          <h2 className="flex flex-col">
            {blok?.eyebrow ? <span className="eyebrow uppercase text-primary pb-2">{blok?.eyebrow}</span> : null}
            <span className="block text-primary">{blok.heading}</span>
          </h2>
        </div>
        <div className="basis-2/3">{richText(blok.content)}</div>
      </div>
    </section>
  )
}
